import { IGuiaClienteReferencia } from './IGuiaClienteReferencia';
import { IGuiaCreateResult } from './IGuiaCreateResult';

export type InHouseStatus = 'idle' | 'loading' | 'ok' | 'none' | 'multiple' | 'error' | 'sinCobertura';

export interface IGuiaWizard {
    seccionId: number;
    seccionAlcanzada: number;
    remitenteId: number;
    destinatarioId: number;
    sucursalRemitenteId: number;
    oficinaLogin: number;
    esEad: number;
    esOcurreDestino: number;
    inHouseStatus: InHouseStatus;
    inHouseMensaje: string;
    unidadMedidaPesoId: number;
    unidadMedidaLongitudId: number;
    tipoServicioId: number;
    tipoEnvioId: number;
    observaciones: string;
    descripcionMercancia: string;
    esSeguroBasico: boolean;
    esSeguroMercancia: boolean;
    valorMercancia?: number | null;
    clienteReferencias: IGuiaClienteReferencia[];
    referenciasCatalogoCargado: boolean;
    createOperationId: string | null;
    createResult: IGuiaCreateResult | null;
}

export const initialGuiaWizard: IGuiaWizard = {
    seccionId: 1,
    seccionAlcanzada: 1,
    remitenteId: 0,
    destinatarioId: 0,
    sucursalRemitenteId: 0,
    oficinaLogin: 0,
    esEad: 0,
    esOcurreDestino: 0,
    inHouseStatus: 'idle',
    inHouseMensaje: '',
    unidadMedidaPesoId: 0,
    unidadMedidaLongitudId: 0,
    tipoServicioId: 0,
    tipoEnvioId: 0,
    observaciones: "",
    descripcionMercancia: "",
    esSeguroBasico: true,
    esSeguroMercancia: false,
    valorMercancia: null,
    clienteReferencias: [],
    referenciasCatalogoCargado: false,
    createOperationId: null,
    createResult: null
};

export function derivarOficinaLogin(sucursalRemitenteId: number): number {
    return sucursalRemitenteId || 0;
}

export function seccionAlcanzadaActual(wizard: IGuiaWizard): number {
    return wizard.seccionAlcanzada ?? wizard.seccionId ?? 1;
}

export function avanzarSeccionGuiaWizard(wizard: IGuiaWizard, seccionId: number): IGuiaWizard {
    return {
        ...wizard,
        seccionId,
        seccionAlcanzada: Math.max(seccionAlcanzadaActual(wizard), seccionId)
    };
}

export function navegarSeccionGuiaWizard(wizard: IGuiaWizard, seccionId: number): IGuiaWizard {
    return {
        ...wizard,
        seccionId
    };
}
